import { combineReducers } from '@reduxjs/toolkit';
import { authApi } from 'services/auth';
import { reverseGeocodeApi } from 'services/reverseGeocode';

import { commandApi } from '../services/command';
import { hubsApi } from '../services/hubs';
import { missionV2Api } from '../services/missionV2';
import { missionV3Api } from '../services/missionV3';
import { realtimeEventsApi } from '../services/realtimeEvents';
import { routesApi } from '../services/routes';
import { systemApi } from '../services/system';
import { systemFleetsApi } from '../services/systemAdmin/fleets';
import { systemTeamsApi } from '../services/systemAdmin/teams';
import { userApi } from '../services/user';
import { vehiclesApi } from '../services/vehicles';
import { vehiclesV2Api } from '../services/vehiclesV2';
import langReducer from './i18n/langSlice';
import configReducer from './setup/configSlice';
import appReducer from './slices/appSlice';
import archiveMissionReducer from './slices/archiveMissionSlice';
import assignMissionReducer from './slices/assignMissionSlice';
import cancelMissionReducer from './slices/cancelMissionSlice';
import claimsReducer from './slices/claimsSlice';
import healthStatusReducer from './slices/healthStatusSlice';
import mrmReducer from './slices/mrmSlice';
import resetMissionReducer from './slices/resetMissionSlice';
import settingsPageReducer from './slices/settingsPageSlice';
import startMissionReducer from './slices/startMissionSlice';
import systemFleetReducer from './slices/systemFleet';
import tokenHandlingReducer from './tokenHandling/tokenSlice';

export const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    healthStatus: healthStatusReducer,
    mrm: mrmReducer,
    startMission: startMissionReducer,
    cancelMission: cancelMissionReducer,
    archiveMission: archiveMissionReducer,
    resetMission: resetMissionReducer,
    assignMission: assignMissionReducer,
    tokenHandling: tokenHandlingReducer,
    settingsPage: settingsPageReducer,
    systemFleet: systemFleetReducer,
    claims: claimsReducer,
    // RTK Query ApiSlices
    users: userApi.reducer,
    systemTeams: systemTeamsApi.reducer,
    systemFleets: systemFleetsApi.reducer,
    hubs: hubsApi.reducer,
    routes: routesApi.reducer,
    vehicles: vehiclesApi.reducer,
    vehiclesV2: vehiclesV2Api.reducer,
    missionV2: missionV2Api.reducer,
    missionV3: missionV3Api.reducer,
    realtimeEvents: realtimeEventsApi.reducer,
    reverseGeocode: reverseGeocodeApi.reducer,
    command: commandApi.reducer,
    system: systemApi.reducer,
    auth: authApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
